export const sidebarWidth: number = 600;
export const sidebarHeaderHeight: number = 70;
export const sidebarNavHeight: number = 60;
export const scrollableContentVerticalGap: number = 5;
